<template>
  <div class="m_m_payee_list">
        <div class="table_btm">
            <el-button class="add_btn border_set_color" icon="el-icon-plus" @click="add_btn">{{$t('main.text361')}}</el-button>
        </div>

        <div class="list_title1">{{$t('main.text362')}}</div>
        <table class="list_table">
            <div v-for="(item,index) in tableData" :key="index">
                <!-- <td>
                    <el-checkbox-group v-model="checkList" @change="checkbox_fun(item)">
                        <el-checkbox :label="item.name">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </td> -->
                <div class="td1">{{item.name}}</div>
                <div class="td2">{{item.address}}</div>
                <div class="td3">{{item.type}}</div>
                <div class="text_r td4">
                    <span class="edit_btn" @click="edit_fun(item)">{{$t('main.text71')}}</span>
                    <span class="delete_btn" @click="delete_fun(item)">{{$t('main.text363')}}</span>
                </div>
            </div>
            <span v-if="page_total<=0" class="no_data_text">{{$t('main.text364')}}</span>
        </table>
        <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="page_total"
            @current-change="current_change"
            ></el-pagination>

    <!-- 添加 -->
    <el-dialog
      :title="$t('main.text361')"
      :visible.sync="add_user_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{$t('main.text365')}}</div>

            <div class="alert_box">
                <el-alert
                    class="alert_style"
                    type="warning"
                    :closable="false"
                    show-icon>
                    <div slot="title" class="alert_text">
                        {{$t('main.text488')}}
                    </div>
                </el-alert>
            </div>

            <el-form-item :label="$t('main.text348')">
              <el-input v-model="add_form.name" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text366')">
              <el-input v-model="add_form.addr" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text343')">
                <!-- BTC ETH ERC TRC BSC -->
                <el-select v-model="add_form.type" :placeholder="$t('main.text135')">
                    <el-option label="BTC" value="BTC"></el-option>
                    <el-option label="ETH" value="ETH"></el-option>
                    <el-option label="ERC" value="ERC"></el-option>
                    <el-option label="TRC" value="TRC"></el-option>
                    <el-option label="BSC" value="BSC"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_user_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="add_dlg_save" class="confirm_btn">
            <span v-if="add_or_edit">{{$t('main.text104')}}</span>
            <span v-else>{{$t('main.text236')}}</span>
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
        :visible.sync="delete_user_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text367')}}
        </div>
        <div class="log_out3">
          {{$t('main.text368')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="delete_user_dlg = false" class="cancel_btn border_set_color2">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="del_dlg_remove">{{$t('main.text369')}}</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {withdraw_address_list,withdraw_address_add,withdraw_address_edit,withdraw_address_del} from '@/api/api';
export default {
    data() {
        return {
            checkList: [],
            add_user_dlg:false,
            delete_user_dlg:false,

            currentPage: 1,//选中的页数
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            tableData:[],
            add_form:{
                name:'',
                addr:'',
                type:''
            },
            add_or_edit:true,//true 默认添加  false 编辑
            edit_item:{},
            old_edit_item:{},
            del_item:{},

        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',this.$t('main.text370'));
        this.get_list();
        this.checkList=[];
    },
    methods: {
        checkbox_fun(item){
            this.checkList=[];
            this.checkList=[item.name];
        },
        get_list(){
            withdraw_address_list({
                page:this.page,
                limit:this.limit
            }).then(res=>{
                if (res.data.code==200) {
                    this.tableData=res.data.data.list;
                    this.page_total=res.data.data.count;
                    // console.log(res.data.data);
                }
            })
        },
        current_change(v){
            // console.log(v);
            this.page=v;
            this.limit=10;
            this.get_list();
        },
        add_btn(){
            this.add_form.name="";
            this.add_form.addr="";
            this.add_form.type="";
            this.add_user_dlg=true;
            this.add_or_edit=true;
        },
        edit_fun(item){
            this.add_form.name=item.name;
            this.add_form.addr=item.address;
            this.add_form.type=item.type;
            this.edit_item=item;
            this.old_edit_item=JSON.parse(JSON.stringify(item));
            
            this.add_user_dlg=true;
            this.add_or_edit=false;
        },
        delete_fun(item){
            this.del_item=item;
            this.delete_user_dlg=true;
        },
        add_dlg_save(){
            if (!this.add_form.name) {
                this.message.ismessage('error',this.$t('main.text371'));
            }
            if (!this.add_form.addr) {
                this.message.ismessage('error',this.$t('main.text372'));
            }
            if (!this.add_form.type) {
                this.message.ismessage('error',this.$t('main.text373'));
            }
            // 添加操作
            if (this.add_or_edit) {
                withdraw_address_add({
                    name:this.add_form.name,
                    address:this.add_form.addr,
                    type:this.add_form.type,
                }).then(res=>{
                    if (res.data.code==200) {
                        this.page=1;
                        this.limit=10;
                        this.currentPage=1;
                        this.get_list();
                        this.add_user_dlg=false;
                        this.message.ismessage('success',this.$t('main.text374'));
                    }else{
                        this.message.ismessage('error',res.data.msg);
                    }
                })
            }else{
                // 编辑
                // 编辑之前做判断

                if (
                    this.add_form.name==this.old_edit_item.name&&
                    this.add_form.addr==this.old_edit_item.address&&
                    this.add_form.type==this.old_edit_item.type
                ) {
                    this.add_user_dlg=false;
                    return false;
                }

                withdraw_address_edit({
                    id:this.edit_item.id,
                    name:this.add_form.name==this.old_edit_item.name?'':this.add_form.name,
                    address:this.add_form.addr==this.old_edit_item.address?'':this.add_form.addr,
                    type:this.add_form.type==this.old_edit_item.type?'':this.add_form.type,
                }).then(res=>{
                    if (res.data.code==200) {
                        this.page=1;
                        this.limit=10;
                        this.currentPage=1;
                        this.get_list();
                        this.add_user_dlg=false;
                        this.message.ismessage('success',this.$t('main.text375'));
                    }else{
                        this.message.ismessage('error',res.data.msg);
                    }
                })
            }
        },
        del_dlg_remove(){
            withdraw_address_del({
                id:this.del_item.id
            }).then(res=>{
                if (res.data.code==200) {
                    this.page=1;
                    this.limit=10;
                    this.currentPage=1;
                    this.get_list();
                    this.message.ismessage('success',this.$t('main.text376'));
                    this.delete_user_dlg=false;
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
        }


    },
}
</script>

<style scoped>
.m_m_payee_list{
    box-sizing: border-box;
    padding: 28px;
    background: #232A36;
    border-radius: 16px;
}
.list_title1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.list_table{
    display: block;
    width: 100%;
}
.list_table>div{
    width: 100%;
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list_table>div:nth-child(odd){
    background: #2B323E;
    border-radius: 12px;
}
.list_table>div>div{
    /* min-width: 130px; */
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
}
.list_table div .td1{
    width: 20%;
}
.list_table div .td2{
    width: 50%;
    word-wrap: break-word;
}
.list_table div .td3{
    width: 10%;
}
.list_table div .td4{
    width: 20%;
}
.list_table .text_r{
    text-align: right;
}
.list_table .el-checkbox{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.list_table >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#fff;
    border-color:#fff;
    box-shadow: 0px 0px 0px 2px #39526F inset;
}
.list_table >>> .el-checkbox__inner{
    border-radius: 50%;
    background: transparent;
    width: 24px;
    height: 24px;
}
.list_table >>> .el-checkbox__inner::after{
    display: none;
}
.edit_btn{
    color: #DEB981;
    margin-right: 40px;
    cursor: pointer;
}
.delete_btn{
    color: #F35F65;
    cursor: pointer;
}
.table_btm{
    /* margin-top: 28px; */
    margin-bottom: 28px;
}
.add_btn,
.add_btn:hover,
.add_btn:focus,
.add_btn:active{
    min-width: 300px;
    height: 44px;
    color: #00C18E;
    background: transparent;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-style:solid;
    border-width: 1.5px;
    border-color:#00C18E;
}
.top_text{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 20px;
}
.border_bottom{
    border: 1px solid #020D16;
}
.no_data_text{
    text-align: center;
    display: inherit;
}
.alert_style {
    margin-bottom: 20px;
}

</style>
